import React from 'react';
import {
  Card,
  Typography
} from '@material-ui/core';
import AboutUsTopBannerPreview from './AboutUsTopBannerPreview';
import AboutUsWelcomeSectionPreview from './AboutUsWelcomeSectionPreview';
import AboutUsProviderSectionPreview from './AboutUsProviderSectionPreview';
import AboutUsCtaFullSectionPreview from './AboutUsCtaFullSectionPreview';
import AboutUsCtaContainerSectionPreview from './AboutUsCtaContainerSectionPreview';


const AboutUsPagePreview = ({values}) => {
  const {
    general: {
      'store_info/about_us_page/is_about_us_page_enabled': isEnabledPage
    },
    page_top_banner: {
      'store_info/about_us_page/is_top_banner_enabled': isEnableTopBanner,
      'store_info/about_us_page/top_banner_image': topBannerImage
    },
    main_welcome_section: {
      'store_info/about_us_page/is_main_content_enabled': isMainContentEnabled,
      'store_info/about_us_page/main_content_heading': mainContentHeading,
      'store_info/about_us_page/main_content_text': mainContentText
    },
    provider_section: {
      'store_info/about_us_page/is_provider_section_enabled': isProviderSectionsEnabled,
      'store_info/about_us_page/provider_image': providerImage,
      'store_info/about_us_page/provider_main_heading': providerMainHeading,
      'store_info/about_us_page/provider_secondary_heading': providerSecondaryHeading,
      'store_info/about_us_page/provider_content': providerContent
    },
    cta_full_section: {
      'store_info/about_us_page/is_cta_full_enabled': isCtaFullEnabled,
      'store_info/about_us_page/cta_full_background_image': ctaFullBackgroundImage,
      'store_info/about_us_page/cta_full_content': ctaFullContent
    },
    cta_container_section: {
      'store_info/about_us_page/is_cta_container_enabled': isCtaContainerEnabled,
      'store_info/about_us_page/cta_container_front_image': ctaContainerFrontImage,
      'store_info/about_us_page/cta_container_back_image': ctaContainerBackImage,
      'store_info/about_us_page/cta_container_content': ctaContainerContent
    }
  } = values;

  return (
    <Card className="p-8">
      <Typography variant="h4" className="mb-5">Preview</Typography>
      {!!isEnabledPage &&
        <div>
          {isEnableTopBanner == 1 &&
            <AboutUsTopBannerPreview
              topBannerImage={topBannerImage}
            />
          }
          {!!isMainContentEnabled &&
            <AboutUsWelcomeSectionPreview
              mainContentHeading={mainContentHeading}
              mainContentText={mainContentText}
            />
          }
          {!!isProviderSectionsEnabled &&
            <AboutUsProviderSectionPreview
              providerImage={providerImage}
              providerMainHeading={providerMainHeading}
              providerSecondaryHeading={providerSecondaryHeading}
              providerContent={providerContent}
            />
          }
          {!!isCtaFullEnabled &&
            <AboutUsCtaFullSectionPreview
              ctaFullBackgroundImage={ctaFullBackgroundImage}
              ctaFullContent={ctaFullContent}
            />
          }
          {!!isCtaContainerEnabled &&
            <AboutUsCtaContainerSectionPreview
              ctaContainerFrontImage={ctaContainerFrontImage}
              ctaContainerBackImage={ctaContainerBackImage}
              ctaContainerContent={ctaContainerContent}
            />
          }
        </div>
      }
      {!isEnabledPage &&
        <Typography variant="body1" className="text-muted w-full text-center my-10">
          About Us Page is disabled.
        </Typography>
      }
      {(!!isEnabledPage && !isEnableTopBanner &&
        !isMainContentEnabled && !isProviderSectionsEnabled &&
        !isCtaFullEnabled && !isCtaContainerEnabled) &&
        <Typography variant="body1" className="text-muted w-full text-center my-10">
          All sections are disabled. Enable one of them or disable all Page under General tab.
        </Typography>
      }
    </Card>
  );
};

export default AboutUsPagePreview;
